import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b16f343"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  class: "header-container",
  style: { backgroundImage: `url('/Static/images/calculator.png')`}
}
const _hoisted_3 = { class: "center-text" }
const _hoisted_4 = { class: "language-wrapper" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex flex-row align-items-center"
}
const _hoisted_6 = { class: "d-flex flex-row align-items-center" }
const _hoisted_7 = { class: "d-flex gap-1 justify-content-between" }
const _hoisted_8 = {
  class: "form-group",
  style: {"flex":"3"}
}
const _hoisted_9 = {
  style: {"width":"685px"},
  for: "tierSelection"
}
const _hoisted_10 = {
  class: "form-group align-items-end",
  style: {"flex":"1"}
}
const _hoisted_11 = {
  class: "label-inputswitch-lineheight",
  for: "showQP"
}
const _hoisted_12 = {
  class: "form-group align-items-end",
  style: {"flex":"1"}
}
const _hoisted_13 = {
  class: "label-inputswitch-lineheight",
  for: "showFee"
}
const _hoisted_14 = {
  key: 0,
  class: "form-group align-items-end",
  style: {"flex":"1"}
}
const _hoisted_15 = {
  class: "label-inputswitch-lineheight",
  for: "showCadac"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "New Business", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "highlight" }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { class: "highlight" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "highlight" }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "highlight" }
const _hoisted_30 = { key: 2 }
const _hoisted_31 = { class: "highlight" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "highlight" }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "highlight" }
const _hoisted_36 = { key: 2 }
const _hoisted_37 = { class: "highlight" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "highlight" }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { class: "highlight" }
const _hoisted_42 = { key: 2 }
const _hoisted_43 = { class: "highlight" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { class: "highlight" }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { class: "highlight" }
const _hoisted_48 = { key: 2 }
const _hoisted_49 = { class: "highlight" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { key: 2 }
const _hoisted_53 = { class: "highlight" }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { key: 1 }
const _hoisted_56 = { key: 2 }
const _hoisted_57 = { class: "highlight" }
const _hoisted_58 = { class: "border-top" }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { class: "highlight" }
const _hoisted_61 = { key: 1 }
const _hoisted_62 = { class: "highlight" }
const _hoisted_63 = { key: 2 }
const _hoisted_64 = { class: "highlight" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, null, -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Renew excl txc", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_68 = { key: 0 }
const _hoisted_69 = { key: 0 }
const _hoisted_70 = { class: "highlight" }
const _hoisted_71 = { key: 0 }
const _hoisted_72 = { class: "highlight" }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { class: "highlight" }
const _hoisted_75 = { key: 0 }
const _hoisted_76 = { class: "highlight" }
const _hoisted_77 = { key: 0 }
const _hoisted_78 = { class: "highlight" }
const _hoisted_79 = { class: "border-top" }
const _hoisted_80 = { key: 0 }
const _hoisted_81 = { class: "highlight" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, null, -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Renew incl txc", -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_85 = { key: 0 }
const _hoisted_86 = { key: 1 }
const _hoisted_87 = { key: 0 }
const _hoisted_88 = { class: "highlight" }
const _hoisted_89 = { key: 1 }
const _hoisted_90 = { class: "highlight" }
const _hoisted_91 = { key: 0 }
const _hoisted_92 = { class: "highlight" }
const _hoisted_93 = { key: 1 }
const _hoisted_94 = { class: "highlight" }
const _hoisted_95 = { key: 0 }
const _hoisted_96 = { class: "highlight" }
const _hoisted_97 = { key: 1 }
const _hoisted_98 = { class: "highlight" }
const _hoisted_99 = { key: 0 }
const _hoisted_100 = { key: 1 }
const _hoisted_101 = { class: "highlight" }
const _hoisted_102 = { key: 0 }
const _hoisted_103 = { key: 1 }
const _hoisted_104 = { class: "highlight" }
const _hoisted_105 = { class: "border-top" }
const _hoisted_106 = { key: 0 }
const _hoisted_107 = { class: "highlight" }
const _hoisted_108 = { key: 1 }
const _hoisted_109 = { class: "highlight" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, null, -1))
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Government excl GPI/CPI", -1))
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_113 = { key: 0 }
const _hoisted_114 = { key: 1 }
const _hoisted_115 = { key: 0 }
const _hoisted_116 = { class: "highlight" }
const _hoisted_117 = { key: 1 }
const _hoisted_118 = { class: "highlight" }
const _hoisted_119 = { key: 0 }
const _hoisted_120 = { class: "highlight" }
const _hoisted_121 = { key: 1 }
const _hoisted_122 = { class: "highlight" }
const _hoisted_123 = { key: 0 }
const _hoisted_124 = { class: "highlight" }
const _hoisted_125 = { key: 1 }
const _hoisted_126 = { class: "highlight" }
const _hoisted_127 = { class: "border-top" }
const _hoisted_128 = { key: 0 }
const _hoisted_129 = { class: "highlight" }
const _hoisted_130 = { key: 1 }
const _hoisted_131 = { class: "highlight" }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, null, -1))
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Government incl GPI/CPI", -1))
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_135 = { key: 0 }
const _hoisted_136 = { key: 1 }
const _hoisted_137 = { key: 0 }
const _hoisted_138 = { class: "highlight" }
const _hoisted_139 = { key: 1 }
const _hoisted_140 = { class: "highlight" }
const _hoisted_141 = { key: 0 }
const _hoisted_142 = { class: "highlight" }
const _hoisted_143 = { key: 1 }
const _hoisted_144 = { class: "highlight" }
const _hoisted_145 = { key: 0 }
const _hoisted_146 = { class: "highlight" }
const _hoisted_147 = { key: 1 }
const _hoisted_148 = { class: "highlight" }
const _hoisted_149 = { class: "border-top" }
const _hoisted_150 = { key: 0 }
const _hoisted_151 = { class: "highlight" }
const _hoisted_152 = { key: 1 }
const _hoisted_153 = { class: "highlight" }
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, null, -1))
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Total New + Renew + Government", -1))
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_157 = { key: 0 }
const _hoisted_158 = { key: 1 }
const _hoisted_159 = { key: 2 }
const _hoisted_160 = { key: 0 }
const _hoisted_161 = { class: "highlight" }
const _hoisted_162 = { key: 1 }
const _hoisted_163 = { class: "highlight" }
const _hoisted_164 = { key: 2 }
const _hoisted_165 = { class: "highlight" }
const _hoisted_166 = { key: 0 }
const _hoisted_167 = { key: 1 }
const _hoisted_168 = { key: 2 }
const _hoisted_169 = { class: "highlight" }
const _hoisted_170 = { key: 0 }
const _hoisted_171 = { key: 1 }
const _hoisted_172 = { class: "highlight" }
const _hoisted_173 = { key: 2 }
const _hoisted_174 = { class: "highlight" }
const _hoisted_175 = { key: 0 }
const _hoisted_176 = { key: 1 }
const _hoisted_177 = { class: "highlight" }
const _hoisted_178 = { key: 2 }
const _hoisted_179 = { class: "highlight" }
const _hoisted_180 = { key: 0 }
const _hoisted_181 = { key: 1 }
const _hoisted_182 = { class: "highlight" }
const _hoisted_183 = { key: 2 }
const _hoisted_184 = { class: "highlight" }
const _hoisted_185 = { class: "border-top" }
const _hoisted_186 = { key: 0 }
const _hoisted_187 = { class: "highlight" }
const _hoisted_188 = { key: 1 }
const _hoisted_189 = { class: "highlight" }
const _hoisted_190 = { key: 2 }
const _hoisted_191 = { class: "highlight" }
const _hoisted_192 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_country_flag = _resolveComponent("country-flag")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].title), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].subtitle), 1)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Dropdown, {
          autoOptionFocus: "",
          tabindex: 3,
          modelValue: _ctx.selectedLanguage,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedLanguage) = $event)),
          inputId: "languageSelection",
          options: _ctx.languages,
          "option-label": "name",
          "append-to": "self",
          class: "w-full md:w-14rem language-menu",
          placeholder: " ",
          scrollheight: "500px"
        }, {
          value: _withCtx((slotProps) => [
            (slotProps.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_country_flag, {
                    class: "flag-icon rounded-lg",
                    country: _ctx.mapLanguageToCountryCode(slotProps.value.code),
                    size: "normal"
                  }, null, 8, ["country"]),
                  _createElementVNode("div", null, _toDisplayString(slotProps.value.name), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          option: _withCtx((slotProps) => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_country_flag, {
                class: "rounded-lg mr-1 my-0",
                country: _ctx.mapLanguageToCountryCode(slotProps.option.code),
                size: "normal"
              }, null, 8, ["country"]),
              _createElementVNode("div", null, _toDisplayString(slotProps.option.name), 1)
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "options"])
      ], 512), [
        [_vShow, _ctx.languages?.length]
      ])
    ]),
    _createElementVNode("form", null, [
      _createElementVNode("section", null, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].dropdown.tier.name), 1),
            _createVNode(_component_Dropdown, {
              autoOptionFocus: "",
              tabindex: 1,
              modelValue: _ctx.selectedTier,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedTier) = $event)),
              inputId: "tierSelection",
              options: _ctx.tiers,
              optionLabel: "name",
              optionValue: "code",
              class: "w-full md:w-14rem"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.qpc), 1),
            _createVNode(_component_InputSwitch, {
              inputId: "showQP",
              modelValue: _ctx.showQP,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showQP) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].toggle.fee.name), 1),
            _createVNode(_component_InputSwitch, {
              inputId: "showFee",
              modelValue: _ctx.showFee,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showFee) = $event))
            }, null, 8, ["modelValue"])
          ]),
          (_ctx.isCadacSales())
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].toggle.cadac.name), 1),
                _createVNode(_component_InputSwitch, {
                  inputId: "showCadac",
                  modelValue: _ctx.showCadac,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showCadac) = $event))
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_16,
        _createElementVNode("table", null, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_17,
              _createElementVNode("th", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.revenue), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.revenueGr1), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.revenueGr2), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.standard), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.growth1), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.growth2), 1),
              (_ctx.showQP)
                ? (_openBlock(), _createElementBlock("th", _hoisted_18, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.qpc), 1))
                : _createCommentVNode("", true),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("th", _hoisted_19, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.fee), 1))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("th", _hoisted_20, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.cadac), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.data.ltFamily.name), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.ltFamily,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inputs.ltFamily) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.ltFamilyGr1,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.inputs.ltFamilyGr1) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.ltFamilyGr2,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.inputs.ltFamilyGr2) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.ltFamily.ppc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.ltFamily.gr1,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.ltFamily.gr2,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              (_ctx.showQP)
                ? (_openBlock(), _createElementBlock("td", _hoisted_21, [
                    _createVNode(_component_InputText, {
                      class: "bg-disabled",
                      type: "text",
                      value: "n.v.t",
                      disabled: true
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("td", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.ltFamily.fee,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.ltFamily.cadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.data.autocadIST.name), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.autocadIST,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.inputs.autocadIST) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.autocadISTGr1,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.inputs.autocadISTGr1) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.autocadISTGr2,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.inputs.autocadISTGr2) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.autocadIST.ppc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.autocadIST.gr1,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.autocadIST.gr2,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              (_ctx.showQP)
                ? (_openBlock(), _createElementBlock("td", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.autocadIST.qp,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("td", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.autocadIST.fee,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.autocadIST.cadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.data.autocadIST_cloud.name), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.autocadIST_cloud,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.inputs.autocadIST_cloud) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.autocadIST_cloudGr1,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.inputs.autocadIST_cloudGr1) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.autocadIST_cloudGr2,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.inputs.autocadIST_cloudGr2) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.autocadIST_cloud.ppc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.autocadIST_cloud.gr1,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.autocadIST_cloud.gr2,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              (_ctx.showQP)
                ? (_openBlock(), _createElementBlock("td", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.autocadIST_cloud.qp,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("td", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.autocadIST_cloud.fee,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.autocadIST_cloud.cadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.data.verticals.name), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.verticals,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.inputs.verticals) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.verticalsGr1,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.inputs.verticalsGr1) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.verticalsGr2,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.inputs.verticalsGr2) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.verticals.ppc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.verticals.gr1,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.verticals.gr2,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              (_ctx.showQP)
                ? (_openBlock(), _createElementBlock("td", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.verticals.qp,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("td", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.verticals.fee,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.verticals.cadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.data.verticals_cloud.name), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.verticals_cloud,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.inputs.verticals_cloud) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.verticals_cloudGr1,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.inputs.verticals_cloudGr1) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.verticals_cloudGr2,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.inputs.verticals_cloudGr2) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.verticals_cloud.ppc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.verticals_cloud.gr1,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.verticals_cloud.gr2,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              (_ctx.showQP)
                ? (_openBlock(), _createElementBlock("td", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.verticals_cloud.qp,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("td", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.verticals_cloud.fee,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.verticals_cloud.cadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.data.cadacIP.name), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.cadacIP,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.inputs.cadacIP) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.cadacIP.ppc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              (_ctx.showQP)
                ? (_openBlock(), _createElementBlock("td", _hoisted_50, [
                    _createVNode(_component_InputText, {
                      class: "bg-disabled",
                      type: "text",
                      value: "n.v.t",
                      disabled: true
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("td", _hoisted_51, [
                    _createVNode(_component_InputText, {
                      class: "bg-disabled",
                      type: "text",
                      value: "n.v.t",
                      disabled: true
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.cadacIP.cadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.data.cadacServices.name), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.cadacServices,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.inputs.cadacServices) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.cadacServices.ppc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              (_ctx.showQP)
                ? (_openBlock(), _createElementBlock("td", _hoisted_54, [
                    _createVNode(_component_InputText, {
                      class: "bg-disabled",
                      type: "text",
                      value: "n.v.t",
                      disabled: true
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("td", _hoisted_55, [
                    _createVNode(_component_InputText, {
                      class: "bg-disabled",
                      type: "text",
                      value: "n.v.t",
                      disabled: true
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.cadacServices.cadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", _hoisted_58, [
              _createElementVNode("td", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].total), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.totalRevenue,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.totalRevenueGr1,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.totalRevenueGr2,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.totals.totalPpc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.totals.totalGr1,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.totals.totalGr2,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              (_ctx.showQP)
                ? (_openBlock(), _createElementBlock("td", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.totals.totalQP,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("td", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.totals.totalFee,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_63, [
                    _createElementVNode("div", _hoisted_64, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.totals.totalCadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _hoisted_65,
        _hoisted_66,
        _createElementVNode("table", null, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_67,
              _createElementVNode("th", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.revenue), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.revenueGr1), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.revenueGr2), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.standard), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.growth1), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.growth2), 1),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("th", _hoisted_68, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.cadac), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.data.ltFamily.name), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.renew_ltFamily,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.inputs.renew_ltFamily) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.renew_ltFamilyGr1,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.inputs.renew_ltFamilyGr1) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.renew_ltFamilyGr2,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.inputs.renew_ltFamilyGr2) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.ltFamily.renew_ppc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.ltFamily.renew_gr1,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.ltFamily.renew_gr2,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.ltFamily.renew_cadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.data.autocadIST.renew_name), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.renew_autocadIST,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.inputs.renew_autocadIST) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.renew_autocadISTGr1,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.inputs.renew_autocadISTGr1) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.renew_autocadISTGr2,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.inputs.renew_autocadISTGr2) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.autocadIST.renew_ppc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.autocadIST.renew_gr1,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.autocadIST.renew_gr2,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.autocadIST.renew_cadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.data.verticals.renew_name), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.renew_verticals,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.inputs.renew_verticals) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.renew_verticalsGr1,
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.inputs.renew_verticalsGr1) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.renew_verticalsGr2,
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.inputs.renew_verticalsGr2) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.verticals.renew_ppc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.verticals.renew_gr1,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.verticals.renew_gr2,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_73, [
                    _createElementVNode("div", _hoisted_74, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.verticals.renew_cadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.data.cadacIP.name), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.renew_cadacIP,
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.inputs.renew_cadacIP) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.cadacIP.renew_ppc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_75, [
                    _createElementVNode("div", _hoisted_76, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.cadacIP.renew_cadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.data.cadacServices.name), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.renew_cadacServices,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.inputs.renew_cadacServices) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.cadacServices.renew_ppc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_77, [
                    _createElementVNode("div", _hoisted_78, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.cadacServices.renew_cadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", _hoisted_79, [
              _createElementVNode("td", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].total), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.renew_totalRevenue,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.renew_totalRevenueGr1,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.renew_totalRevenueGr2,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.totals.renew_totalPpc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.totals.renew_totalGr1,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.totals.renew_totalGr2,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_80, [
                    _createElementVNode("div", _hoisted_81, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.totals.renew_totalCadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _hoisted_82,
        _hoisted_83,
        _createElementVNode("table", null, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_84,
              _createElementVNode("th", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.revenue), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.revenueGr1), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.revenueGr2), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.standard), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.growth1), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.growth2), 1),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("th", _hoisted_85, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.fee), 1))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("th", _hoisted_86, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.cadac), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.data.ltFamily.name), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.renew_incl_ltFamily,
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.inputs.renew_incl_ltFamily) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.renew_incl_ltFamilyGr1,
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.inputs.renew_incl_ltFamilyGr1) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.renew_incl_ltFamilyGr2,
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.inputs.renew_incl_ltFamilyGr2) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.ltFamily.renew_incl_ppc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.ltFamily.renew_incl_gr1,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.ltFamily.renew_incl_gr2,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("td", _hoisted_87, [
                    _createElementVNode("div", _hoisted_88, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.ltFamily.renew_incl_fee,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_89, [
                    _createElementVNode("div", _hoisted_90, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.ltFamily.renew_incl_cadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.data.autocadIST.renew_name), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.renew_incl_autocadIST,
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.inputs.renew_incl_autocadIST) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.renew_incl_autocadISTGr1,
                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.inputs.renew_incl_autocadISTGr1) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.renew_incl_autocadISTGr2,
                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.inputs.renew_incl_autocadISTGr2) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.autocadIST.renew_incl_ppc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.autocadIST.renew_incl_gr1,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.autocadIST.renew_incl_gr2,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("td", _hoisted_91, [
                    _createElementVNode("div", _hoisted_92, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.autocadIST.renew_incl_fee,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_93, [
                    _createElementVNode("div", _hoisted_94, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.autocadIST.renew_incl_cadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.data.verticals.renew_name), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.renew_incl_verticals,
                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.inputs.renew_incl_verticals) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.renew_incl_verticalsGr1,
                  "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.inputs.renew_incl_verticalsGr1) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.renew_incl_verticalsGr2,
                  "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.inputs.renew_incl_verticalsGr2) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.verticals.renew_incl_ppc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.verticals.renew_incl_gr1,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.verticals.renew_incl_gr2,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("td", _hoisted_95, [
                    _createElementVNode("div", _hoisted_96, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.verticals.renew_incl_fee,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_97, [
                    _createElementVNode("div", _hoisted_98, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.verticals.renew_incl_cadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.data.cadacIP.name), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.renew_incl_cadacIP,
                  "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.inputs.renew_incl_cadacIP) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.cadacIP.renew_incl_ppc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("td", _hoisted_99, [
                    _createVNode(_component_InputText, {
                      class: "bg-disabled",
                      type: "text",
                      value: "n.v.t",
                      disabled: true
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_100, [
                    _createElementVNode("div", _hoisted_101, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.cadacIP.renew_incl_cadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.data.cadacServices.name), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.renew_incl_cadacServices,
                  "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.inputs.renew_incl_cadacServices) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.cadacServices.renew_incl_ppc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("td", _hoisted_102, [
                    _createVNode(_component_InputText, {
                      class: "bg-disabled",
                      type: "text",
                      value: "n.v.t",
                      disabled: true
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_103, [
                    _createElementVNode("div", _hoisted_104, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.cadacServices.renew_incl_cadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", _hoisted_105, [
              _createElementVNode("td", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].total), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.renew_incl_totalRevenue,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.renew_incl_totalRevenueGr1,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.renew_incl_totalRevenueGr2,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.totals.renew_incl_totalPpc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.totals.renew_incl_totalGr1,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.totals.renew_incl_totalGr2,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("td", _hoisted_106, [
                    _createElementVNode("div", _hoisted_107, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.totals.renew_incl_totalFee,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_108, [
                    _createElementVNode("div", _hoisted_109, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.totals.renew_incl_totalCadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _hoisted_110,
        _hoisted_111,
        _createElementVNode("table", null, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_112,
              _createElementVNode("th", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.revenue), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.standard), 1),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("th", _hoisted_113, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.fee), 1))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("th", _hoisted_114, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.cadac), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.data.ltFamily.name), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.gov_ltFamily,
                  "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.inputs.gov_ltFamily) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.ltFamily.gov_ppc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("td", _hoisted_115, [
                    _createElementVNode("div", _hoisted_116, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.ltFamily.gov_fee,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_117, [
                    _createElementVNode("div", _hoisted_118, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.ltFamily.gov_cadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.data.autocadIST.renew_name), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.gov_autocadIST,
                  "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.inputs.gov_autocadIST) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.autocadIST.gov_ppc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("td", _hoisted_119, [
                    _createElementVNode("div", _hoisted_120, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.autocadIST.gov_fee,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_121, [
                    _createElementVNode("div", _hoisted_122, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.autocadIST.gov_cadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.data.verticals.renew_name), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.gov_verticals,
                  "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.inputs.gov_verticals) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.verticals.gov_ppc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("td", _hoisted_123, [
                    _createElementVNode("div", _hoisted_124, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.verticals.gov_fee,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_125, [
                    _createElementVNode("div", _hoisted_126, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.verticals.gov_cadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", _hoisted_127, [
              _createElementVNode("td", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].total), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.gov_totalRevenue,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.totals.gov_totalPpc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("td", _hoisted_128, [
                    _createElementVNode("div", _hoisted_129, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.totals.gov_totalFee,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_130, [
                    _createElementVNode("div", _hoisted_131, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.totals.gov_totalCadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _hoisted_132,
        _hoisted_133,
        _createElementVNode("table", null, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_134,
              _createElementVNode("th", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.revenue), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.standard), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.cpi), 1),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("th", _hoisted_135, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.fee), 1))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("th", _hoisted_136, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.cadac), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.data.ltFamily.name), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.gov_incl_ltFamily,
                  "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.inputs.gov_incl_ltFamily) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.ltFamily.gov_incl_ppc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.ltFamily.gov_incl_cpi,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("td", _hoisted_137, [
                    _createElementVNode("div", _hoisted_138, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.ltFamily.gov_incl_fee,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_139, [
                    _createElementVNode("div", _hoisted_140, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.ltFamily.gov_incl_cadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.data.autocadIST.renew_name), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.gov_incl_autocadIST,
                  "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.inputs.gov_incl_autocadIST) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.autocadIST.gov_incl_ppc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.autocadIST.gov_incl_cpi,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("td", _hoisted_141, [
                    _createElementVNode("div", _hoisted_142, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.autocadIST.gov_incl_fee,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_143, [
                    _createElementVNode("div", _hoisted_144, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.autocadIST.gov_incl_cadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.data.verticals.renew_name), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.inputs.gov_incl_verticals,
                  "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.inputs.gov_incl_verticals) = $event)),
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.verticals.gov_incl_ppc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.verticals.gov_incl_cpi,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("td", _hoisted_145, [
                    _createElementVNode("div", _hoisted_146, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.verticals.gov_incl_fee,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_147, [
                    _createElementVNode("div", _hoisted_148, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.computedValues.verticals.gov_incl_cadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", _hoisted_149, [
              _createElementVNode("td", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].total), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.gov_incl_totalRevenue,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.totals.gov_incl_totalPpc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.totals.gov_incl_totalCpi,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("td", _hoisted_150, [
                    _createElementVNode("div", _hoisted_151, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.totals.gov_incl_totalFee,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_152, [
                    _createElementVNode("div", _hoisted_153, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.totals.gov_incl_totalCadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _hoisted_154,
        _hoisted_155,
        _createElementVNode("table", null, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_156,
              _createElementVNode("th", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.revenue), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.revenueGr1), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.revenueGr2), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.standard), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.growth1), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.growth2), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.cpi), 1),
              (_ctx.showQP)
                ? (_openBlock(), _createElementBlock("th", _hoisted_157, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.qpc), 1))
                : _createCommentVNode("", true),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("th", _hoisted_158, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.fee), 1))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("th", _hoisted_159, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].headers.cadac), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].total_new), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.totalRevenue,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.totalRevenueGr1,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.totalRevenueGr2,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.totals.totalPpc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.totals.totalGr1,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.totals.totalGr2,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              (_ctx.showQP)
                ? (_openBlock(), _createElementBlock("td", _hoisted_160, [
                    _createElementVNode("div", _hoisted_161, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.totals.totalQP,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("td", _hoisted_162, [
                    _createElementVNode("div", _hoisted_163, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.totals.totalFee,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_164, [
                    _createElementVNode("div", _hoisted_165, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.totals.totalCadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].total_renew), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.renew_totalRevenue,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.renew_totalRevenueGr1,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.renew_totalRevenueGr2,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.totals.renew_totalPpc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.totals.renew_totalGr1,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.totals.renew_totalGr2,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              (_ctx.showQP)
                ? (_openBlock(), _createElementBlock("td", _hoisted_166, [
                    _createVNode(_component_InputText, {
                      class: "bg-disabled",
                      type: "text",
                      value: "n.v.t",
                      disabled: true
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("td", _hoisted_167, [
                    _createVNode(_component_InputText, {
                      class: "bg-disabled",
                      type: "text",
                      value: "n.v.t",
                      disabled: true
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_168, [
                    _createElementVNode("div", _hoisted_169, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.totals.renew_totalCadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].total_renew_incl), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.renew_incl_totalRevenue,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.renew_incl_totalRevenueGr1,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.renew_incl_totalRevenueGr2,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.totals.renew_incl_totalPpc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.totals.renew_incl_totalGr1,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.totals.renew_incl_totalGr2,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              (_ctx.showQP)
                ? (_openBlock(), _createElementBlock("td", _hoisted_170, [
                    _createVNode(_component_InputText, {
                      class: "bg-disabled",
                      type: "text",
                      value: "n.v.t",
                      disabled: true
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("td", _hoisted_171, [
                    _createElementVNode("div", _hoisted_172, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.totals.renew_incl_totalFee,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_173, [
                    _createElementVNode("div", _hoisted_174, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.totals.renew_incl_totalCadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].total_gov), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.gov_totalRevenue,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.totals.gov_totalPpc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              (_ctx.showQP)
                ? (_openBlock(), _createElementBlock("td", _hoisted_175, [
                    _createVNode(_component_InputText, {
                      class: "bg-disabled",
                      type: "text",
                      value: "n.v.t",
                      disabled: true
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("td", _hoisted_176, [
                    _createElementVNode("div", _hoisted_177, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.totals.gov_totalFee,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_178, [
                    _createElementVNode("div", _hoisted_179, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.totals.gov_totalCadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].total_gov_incl), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.computedValues.gov_incl_totalRevenue,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.totals.gov_incl_totalPpc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputText, {
                  class: "bg-disabled",
                  type: "text",
                  value: "n.v.t",
                  disabled: true
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.totals.gov_incl_totalCpi,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              (_ctx.showQP)
                ? (_openBlock(), _createElementBlock("td", _hoisted_180, [
                    _createVNode(_component_InputText, {
                      class: "bg-disabled",
                      type: "text",
                      value: "n.v.t",
                      disabled: true
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("td", _hoisted_181, [
                    _createElementVNode("div", _hoisted_182, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.totals.gov_incl_totalFee,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_183, [
                    _createElementVNode("div", _hoisted_184, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.totals.gov_incl_totalCadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tr", _hoisted_185, [
              _createElementVNode("td", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].total), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.combinedTotals.combined_totalRevenue,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.combinedTotals.combined_totalRevenueGr1,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.combinedTotals.combined_totalRevenueGr2,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.combinedTotals.combined_totalPpc,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.combinedTotals.combined_totalGr1,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.combinedTotals.combined_totalGr2,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.combinedTotals.combined_totalCpi,
                  disabled: true,
                  mode: "currency",
                  currency: "EUR",
                  locale: "nl-NL"
                }, null, 8, ["modelValue"])
              ]),
              (_ctx.showQP)
                ? (_openBlock(), _createElementBlock("td", _hoisted_186, [
                    _createElementVNode("div", _hoisted_187, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.combinedTotals.combined_totalQP,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showFee)
                ? (_openBlock(), _createElementBlock("td", _hoisted_188, [
                    _createElementVNode("div", _hoisted_189, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.combinedTotals.combined_totalFee,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isCadacSales() && _ctx.showCadac)
                ? (_openBlock(), _createElementBlock("td", _hoisted_190, [
                    _createElementVNode("div", _hoisted_191, [
                      _createVNode(_component_InputNumber, {
                        modelValue: _ctx.combinedTotals.combined_totalCadac,
                        disabled: true,
                        mode: "currency",
                        currency: "EUR",
                        locale: "nl-NL"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_192, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].disclaimer.title) + ":", 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].disclaimer.p1), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].disclaimer.p2), 1),
          _createElementVNode("p", null, [
            _createElementVNode("small", null, _toDisplayString(_ctx.texts[_ctx.selectedLanguage.code].disclaimer.small), 1)
          ])
        ])
      ])
    ])
  ]))
}